import React,{useContext} from 'react';
//import Header from '../Header';
import HeaderEmpresaInt  from './HeaderEmpresaInt.jsx';
//import {GlobalParamCont} from '../../../App.js';
function HeaderEmpresa(props) {

  const lista = [  
    {  
        "Id":1,
        "Nombre":"Almacén Mozel S.A."
    },
    {  
        "Id":3,
        "Nombre":"Repuestos La Uruca"
    },
    {  
        "Id":14,
        "Nombre":"Empresa Prueba"
    },
    {  
       "Id":12,
       "Nombre":"Patitos SA"
    }
]
const nombreSistema = "LDFAS Contabilidad";
//const globalParamCont = useContext(GlobalParamCont);
  return (
    <header>
        <HeaderEmpresaInt
        lista={props.lstEmpresas}
        nombreSistema={props.nombreSistema}
        empresaId = {props.empresaId}//{globalParamCont.globalParam.EmpresaId.value}
        onChange= {props.handlerEmpresas} //{globalParamCont.globalDispatch}
        />
    </header>
  );
};
export default HeaderEmpresa